/* eslint-disable no-param-reassign */
import React, { PureComponent } from 'react'
import _ from 'lodash'
import { Dropdown } from 'semantic-ui-react'

import DriverListItem from './DriverListItem'

export default class DriverList extends PureComponent {
  getDriverOrders = tel => {
    const { orders } = this.props

    return _.filter(
      orders,
      order => order.status === 'delivered' && order.deliverer && order.deliverer === tel
    ).length
  }

  render() {
    const { drivers } = this.props
    const availableDrivers = _.filter(drivers, {
      status: 'available',
    })

    const labelColor = availableDrivers.length > 0 ? 'green' : 'red'

    return (
      <Dropdown
        text={`${availableDrivers.length}/${drivers.length} Drivers available`}
        icon="bicycle"
        floating
        labeled
        button
        className={`icon ${labelColor}`}
      >
        <Dropdown.Menu
          style={{
            maxHeight: '70vh',
            overflow: 'auto',
            width: 500,
            left: -155,
          }}
        >
          <Dropdown.Header content="list of drivers" />
          {_.map(drivers, (driver, index) => (
            <DriverListItem
              driver={driver}
              key={driver.tel}
              index={index}
              todayOrders={this.getDriverOrders(driver.tel)}
            />
          ))}
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/DriverList.js